import React, { createContext, useState, useContext, useEffect } from 'react';

const AppThemeContext = createContext();

export const useAppTheme = () => {
  const context = useContext(AppThemeContext);
  if (!context) {
    throw new Error('useAppTheme must be used within an AppThemeProvider');
  }
  return context;
};

export const AppThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    // Get saved theme from localStorage or default to 'gradient'
    const savedTheme = localStorage.getItem('app-theme');
    // Reset to gradient if blizzard was saved (since we removed it)
    if (savedTheme === 'blizzard') {
      localStorage.setItem('app-theme', 'gradient');
      return 'gradient';
    }
    return savedTheme || 'gradient';
  });

  useEffect(() => {
    // Save theme preference to localStorage
    localStorage.setItem('app-theme', currentTheme);

    // Apply theme class to body
    document.body.className = `theme-${currentTheme}`;
  }, [currentTheme]);

  const toggleTheme = () => {
    setCurrentTheme(prev => {
      // Cycle through themes: gradient -> nightvision -> cyberpunk -> submarine -> gradient
      if (prev === 'gradient') return 'nightvision';
      if (prev === 'nightvision') return 'cyberpunk';
      if (prev === 'cyberpunk') return 'submarine';
      return 'gradient';
    });
  };

  const setTheme = (theme) => {
    if (['gradient', 'nightvision', 'cyberpunk', 'submarine'].includes(theme)) {
      setCurrentTheme(theme);
    }
  };

  return (
    <AppThemeContext.Provider value={{ currentTheme, toggleTheme, setTheme }}>
      {children}
    </AppThemeContext.Provider>
  );
};